module.exports = __webpack_public_path__ + "static/media/half_circle.9fd4fbc5.svg";